<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-arrow-left-right"></i>
              Transferencia entre depósitos
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="movement-product">Producto</label>
              <div v-if="product?.name" class="form-card__static">{{ product.name }}</div>
              <typeahead
                v-if="productId == null"
                :name="'product'"
                :default="productDefault"
                :placeh="'Buscar producto por nombre'"
                :custom-class="[]"
                :clean-on="false"
                :externalsrc="'/api/products/getProducts'"
                limit-chars="1"
                @choosed="productChoosed"
              />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="movement-origin">Depósito origen</label>
              <q-select v-model="movement.origin_select" :options="warehouseOptions" placeholder="- Seleccionar depósito -" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="movement-destination">Depósito destino</label>
              <q-select v-model="movement.destination_select" :options="warehouseOptions" placeholder="- Seleccionar depósito -" />
              <p v-if="sameWarehouse" class="form-card__error">
                <i class="bi bi-exclamation-triangle"></i>
                El depósito destino no puede ser igual al de origen.
              </p>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="movement-quantity">Cantidad</label>
              <input
                id="movement-quantity"
                v-model="movement.quantity"
                type="number"
                class="form-control"
                placeholder="0"
              >
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close()">Cancelar</button>
            <button type="button" class="form-card__btn form-card__btn--primary" :disabled="!canSave || isSaving" @click="saveStockMovement()">
              <i class="bi bi-check-lg"></i>
              Guardar movimiento
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import typeahead from '../../global/Typeahead.vue';
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: {
    typeahead,
    QSelect
  },
  props: ["productId"],
  data() {
    return {
      product: null,
      warehouses: [],
      movement: {
        product_id: null,
        quantity: null,
        origin_select: null,
        destination_select: null,
      },
      isSaving: false,
    };
  },
  watch: {
    productId: function(value) {
      if (value != null) {
        this.getProduct(value);
      } else {
        this.product = null;
      }
    },
  },
  mounted() {
    this.getWarehouses();
    if (this.productId != null) {
      this.movement.product_id = this.productId;
      this.getProduct(this.productId);
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getProduct(id) {
      var vm = this;
      this.$http.get("/api/products/view/" + id).then((response) => {
        vm.product = response.data.data;
      });
    },
    getWarehouses() {
      var vm = this;
      vm.isLoading = true;
      this.$http.get("/api/warehouses/list").then((response) => {
        vm.warehouses = response.data.data;
        vm.isLoading = false;
      });
    },
    saveStockMovement() {
      if (this.isSaving) return;
      this.isSaving = true;
      var vm = this;
      this.$http.post("/api/movements/addWarehouse", this.movement)
        .then(() => {
          vm.$emit("confirmsavemovement");
        })
        .finally(() => {
          vm.isSaving = false;
        });
    },
    productChoosed(data) {
      this.movement.product_id = data.id;
    },
  },
  computed: {
    idState() {
      return this.movement.product_id != null;
    },
    sameWarehouse() {
      const m = this.movement;
      return (
        m.origin_select != null &&
        m.destination_select != null &&
        m.origin_select === m.destination_select
      );
    },
    canSave() {
      const m = this.movement;
      return (
        m.product_id != null &&
        m.origin_select != null &&
        m.destination_select != null &&
        !this.sameWarehouse &&
        m.quantity !== null &&
        m.quantity !== '' &&
        Number(m.quantity) > 0
      );
    },
    productDefault() {
      return this.product != null ? (this.product.barcode != null ? this.product.barcode : this.product.name) : '';
    },
    warehouseOptions() {
      return this.warehouses.map(warehouse => ({ value: warehouse.id, label: warehouse.name }));
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.form-card__static {
  font-size: 13px;
  color: var(--text);
  padding: 6px 0;
  font-weight: 500;
}

.form-card__field >>> .typeahead__container {
  margin-top: 0;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
